<template>
    <div class="relative flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
        <div class="flex flex-row justify-between">
            <div class="px-6 py-4">
                <span class="text-gray-300 font-bold">BETA</span>
            </div>
            <div class="px-6 py-4">
                <div v-if="$page.props.auth.user" class="hidden sm:flex sm:items-center sm:ml-6">
                    <!-- Settings Dropdown -->
                    <div class="ml-3 relative">
                        <BreezeDropdown align="right" width="48">
                            <template #trigger>
                                        <span class="inline-flex rounded-md">
                                            <button type="button"
                                                    class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150">
                                                {{ $page.props.auth.user.name }}

                                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd"
                                                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                          clip-rule="evenodd"/>
                                                </svg>
                                            </button>
                                        </span>
                            </template>

                            <template #content>
                                <BreezeDropdownLink :href="route('tig::users.edit')">
                                    Account Settings
                                </BreezeDropdownLink>
                                <BreezeDropdownLink :href="route('logout')" method="post" as="button">
                                    Log Out
                                </BreezeDropdownLink>
                            </template>
                        </BreezeDropdown>
                    </div>
                </div>

                <template v-else>
                    <Link :href="route('login')" class="text-sm text-gray-700 underline">
                        Log in
                    </Link>

                    <Link :href="route('register')" class="ml-4 text-sm text-gray-700 underline">
                        Register
                    </Link>
                </template>
            </div>
        </div>
        <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
	    <p class="text-center rounded-md px-2 py-1 mb-4" style="border: 1px solid #f96854; background-color: #f9685420;">Support the development and hosting costs of this site on <a style="color: #f96854;"  href="https://patreon.com/hyperbolus">Patreon</a></p>
            <slot/>
            <div class="flex justify-center my-4 sm:items-center sm:justify-between">
                <slot name="footer"/>
            </div>
        </div>
    </div>
</template>
<script>
import {Link} from '@inertiajs/inertia-vue3';
import BreezeDropdown from "@/Components/Dropdown";
import BreezeDropdownLink from "@/Components/DropdownLink";

export default {
    components: {
        Link,
        BreezeDropdown,
        BreezeDropdownLink,
    },
    props: {
        auth: Array,
        app: Array
    },
}
</script>
